import { Link } from 'react-router-dom'

import styled from 'styled-components'

import { colors } from '../../../../shared/styles/colors'

export const Container = styled.div`
  display: flex;
  height: 100vh;

  align-items: center;
  justify-content: space-between;

  flex-direction: column;

  background: ${colors.blue};

  padding: 50px 0px;
`

export const Logo = styled.img`
  width: 297px;
  height: 93px;
`

export const ContainerForm = styled.div`
  width: 350px;
  height: 400px;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  padding: 15px 0px;

  button {
    margin-top: 30px;
  }
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Forgot = styled(Link)`
  text-decoration: underline;

  font-style: italic;
  font-weight: 500;
  font-size: 14px;

  color: ${colors.white};

  align-self: flex-end;
`

export const TextLoginPage = styled.span`
  font-weight: 700;
  font-size: 30px;
  color: ${colors.white};

  @media (max-width: 1366px) {
    font-size: 25px;
  }
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;

  border-top: 1px solid white;
  width: 75%;
  padding-top: 25px;

  button {
    margin-top: 30px;
  }
`

export const Divider = styled.span`
  color: ${colors.white};
`

export const ContainerForgot = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding-top: 50px;
`
